<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <div class="sf-form-select-wrapper">
      <select v-model="locale" class="sf-form-select" name="language">
        <option
          v-for="lang in graphAvailableLanguages"
          :key="lang.locale"
          :value="lang.locale"
        >
          {{ lang.language }}
        </option>
      </select>
    </div>
    <SfButtonDs
      v-if="isPersisted && !readOnly"
      variant="danger"
      @click="destroyWithConfirm()"
    >
      {{ I18n.t('js.report_graph.edit.destroy') }}
    </SfButtonDs>
    <SfButtonDs
      v-if="!readOnly"
      variant="primary"
      :loading="saving"
      data-walkthrough-id="chart-editor-save"
      @click="submit()"
    >
      {{ I18n.t('js.report_graph.edit.save') }}
    </SfButtonDs>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

const ENTER = 'Enter'
const TEXTAREA = 'TEXTAREA'

export default {
  components: { SfButtonDs },
  computed: {
    ...mapState(['currentLocale', 'readOnly', 'saving']),
    ...mapGetters([
      'graphCurrentTitle',
      'graphAvailableLanguages',
      'isPersisted',
    ]),
    locale: {
      get() {
        return this.currentLocale
      },
      set(newLocale) {
        this.setCurrentLocale({ locale: newLocale })
      },
    },
  },
  mounted() {
    if (!this.readOnly) {
      this._keyHandler = (event) => {
        if (event.key === ENTER && event.target.tagName !== TEXTAREA) {
          this.submit()
        }
      }
      document.body.addEventListener('keyup', this._keyHandler)
    }
  },
  beforeUnmount() {
    if (this._keyHandler)
      document.body.removeEventListener('keyup', this._keyHandler)
  },
  methods: {
    ...mapActions(['setCurrentLocale', 'deleteGraph', 'saveGraph']),
    destroyWithConfirm() {
      window.sfRemoveConfirm({
        name: this.graphCurrentTitle,
        onConfirm: this.deleteGraph,
      })
    },
    submit() {
      this.saveGraph()
    },
  },
}
</script>
